import React from 'react';

/**
 * App-wide error boundary for protected route content.
 *
 * Catches render/lifecycle errors so a transient failure degrades to a graceful
 * "reload" card (instead of a blank white screen), and logs the error + React
 * component stack to the console. With build.sourcemap enabled the component stack
 * deminifies, so the failing component/line can be identified from a production
 * report (e.g. the intermittent "x.find is not a function" useMemo crash).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error(
      'App error boundary caught an error:\n', error,
      '\nComponent stack:', info?.componentStack,
    );
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}
      >
        <div
          style={{
            maxWidth: 460,
            textAlign: 'center',
            border: '1px solid #003366',
            borderRadius: 8,
            padding: '2rem',
            background: '#fff',
          }}
        >
          <div style={{ fontSize: '2rem', color: '#f0a500', marginBottom: '0.5rem' }}>
            <i className="bi bi-exclamation-triangle"></i>
          </div>
          <h5 style={{ color: '#072040', marginBottom: '0.5rem' }}>Something went wrong</h5>
          <p style={{ color: '#6c757d', fontSize: '0.9rem', marginBottom: '1.25rem' }}>
            This page hit an unexpected error. Reloading usually fixes it. If it keeps
            happening, please let the team know.
          </p>
          <button
            className="btn btn-primary"
            style={{ backgroundColor: '#072040', borderColor: '#072040' }}
            onClick={this.handleReload}
          >
            <i className="bi bi-arrow-clockwise me-1"></i>Reload page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
